import { IModuleMeta } from '@/contracts/core/module/interface/IModuleMeta'
import { IApi } from '@/contracts/core/api/interface/IApi'
import { IModuleSocket } from '@/contracts/core/module/interface/IModuleSocket'
import { EnumViewType } from '@/contracts/core/module/enum/EnumViewType'
import { IZone } from '@/contracts/system-modules/share/IZone'

/** Номер формата содержимого, который клиент понимает и пишет: 2 — индексы, фон, выравнивание */
export const NOTE_FORMAT = 2

export default class implements IModuleMeta {
  getCode(): string {
    return 'note'
  }
  registerApi(): IApi[] {
    return []
  }
  registerSocker(): IModuleSocket[] {
    return []
  }
  getZones(): IZone[] {
    return [{ code: 'note.notes', module: this.getCode(), title: 'Notes' }]
  }
  viewTypes(): EnumViewType[] {
    return [
      EnumViewType.WINDOW,
      EnumViewType.WIDGET,
    ]
  }

  getParentId(): string {
    return 'common'
  }

  getModuleId(): string {
    return this.getCode() + '_' + this.getVersion()
  }

  getTitle(): string {
    return 'Notes'
  }

  getVersion(): string {
    return 'v1'
  }

  getIcon(): string {
    return 'flaticon-bookmark-white'
  }
}
